module.exports = __webpack_public_path__ + "static/media/general-reception-custom-sample.5a1ae5c9.png";